import { render, staticRenderFns } from "./memo-form.vue?vue&type=template&id=5f201b92"
import script from "./memo-form.vue?vue&type=script&lang=js"
export * from "./memo-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports